<template>
  <el-row>
    <list-template ref="list-template" @onDataFilter="onDataFilter" actionUrl="/clue/findOneBuyCarClue.action"
                   :queryParams="formInline">
      <template slot="searchButton" scope="scope">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-date-picker
              v-model="formInline.createTime"
              type="daterange"
              @change="onCreateTimeChange"
              start-placeholder="选择创建起始时间"
              end-placeholder="选择创建结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="$refs['list-template'].search()">搜索</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot="item" scope="scope">

        <el-row>
          <el-table
            :data="scope.datas"
            border
            style="width: 100%">
            <el-table-column
              label="询价人"
            >
              <template scope="scope">
                <span style="margin-left: 10px">{{ scope.row.linkman }}  {{ scope.row.linkmanPhone }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="询价车系">
              <template scope="scope">
                <p> {{ scope.row.series }}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="渠道来源"
              v-if="loginInfo.loginPath!='channel'">
              <template scope="scope">
                <span style="margin-left: 10px">{{ scope.row.mediaSource }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="询价时间 ">
              <template scope="scope">
                <p class=" text-nowrap">{{ scope.row.createTime}}</p>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isAdmin"
              label="官方备注"
              prop="remark">
              <template scope="scope">
                <p class=" text-nowrap">{{ scope.row.remark}} </p>
                <el-button @click="editRemark(scope.row.id)" type="text">{{scope.row.remark?'修改':'备注'}}</el-button>

              </template>
            </el-table-column>

          </el-table>
        </el-row>

      </template>
    </list-template>

  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import ClueModel from '@/framework/models/clueModel'
import ListTemplate from '@/components/ListTemplate'
import tooltipCommon from '@/components/tooltipCommon'

export default {
  name: 'channel-management',
  extends: BasicPager,
  data: function () {
    return {
      isAdmin: false,
      passwordForm: {
        id: null,
        account: null,
        password: null
      },
      distributionForm: {
        id: null,
        maintainWorkerId: null,
        maintainWorkerName: null
      },
      passwordRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      },
      distributionRules: {
        employeeId: [
          { required: true, message: '请选择维护人', trigger: 'change' }
        ]
      },
      formInline: {
        createTime: null,
        startTime: null,
        endTime: null,
        query: null
      }
    }
  },
  components: {
    ListTemplate,
    tooltipCommon
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
  },
  methods: {
    editRemark: function (clueId) {
      this.$prompt('请输入线索备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '备注不能为空！ '
          })

          return
        }

        let _this = this
        let params = {
          clueId: clueId,
          note: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.$refs['list-template'].search()
          },
          error: function () {
            _this.$message({
              type: 'error',
              message: '操作失败！ '
            })
          }
        }

        ClueModel.setOneBuyCarClueNote(this, params, listener)
      })
    },
    onCreateTimeChange: function () {
      let createTime = this.formInline.createTime

      if (createTime && createTime[0]) {
        this.formInline.startTime = createTime[0].getTime()
        this.formInline.endTime = createTime[1].getTime()
      } else {
        this.formInline.startTime = null
        this.formInline.endTime = null
      }

      this.$refs['list-template'].search()
    },

    onDataFilter: function (dataInfo) {

    }

  }
}
</script>
